"use strict";

import { createPluginUI } from "molstar/lib/mol-plugin-ui";
import { renderReact18 } from "molstar/lib/mol-plugin-ui/react18";
import { PluginUIContext } from "molstar/lib/mol-plugin-ui/context";
import { PluginConfig } from "molstar/lib/mol-plugin/config";
import { PluginSpec } from "molstar/lib/mol-plugin/spec";
import {
  DefaultPluginUISpec,
} from "molstar/lib/mol-plugin-ui/spec";
import { PluginCommands } from "molstar/lib/mol-plugin/commands";
import { PluginContext } from "molstar/lib/mol-plugin/context";
import {
  StateSelection,
  StateTransform,
  StateBuilder,
} from "molstar/lib/mol-state";
import { createStructureRepresentationParams } from "molstar/lib/mol-plugin-state/helpers/structure-representation-params";
import { PluginStateObject } from "molstar/lib/mol-plugin-state/objects";
import { OverpaintStructureRepresentation3DFromBundle } from "molstar/lib/mol-plugin-state/transforms/representation";
import { QualityAssessment } from "molstar/lib/extensions/model-archive/quality-assessment/prop";
import { MAQualityAssessment } from "molstar/lib/extensions/model-archive/quality-assessment/behavior";
import {
  Model,
  Structure,
  StructureElement,
  StructureProperties,
  StructureQuery,
} from "molstar/lib/mol-model/structure";
import { AtomicHierarchy } from "molstar/lib/mol-model/structure/model/properties/atomic";
import { atoms } from "molstar/lib/mol-model/structure/query/queries/generators";
import { Color } from "molstar/lib/mol-util/color";
import { ParamDefinition } from "molstar/lib/mol-util/param-definition";
import { round } from "molstar/lib/mol-util";
import { clamp } from "molstar/lib/mol-math/interpolate";
import { SingleAsyncQueue } from "molstar/lib/mol-util/single-async-queue";
import { ScatterPlotSvg } from "molstar/lib/mol-plugin-ui/controls/icons";
import { ParameterControls } from "molstar/lib/mol-plugin-ui/controls/parameters";
import { useBehavior } from "molstar/lib/mol-plugin-ui/hooks/use-behavior";
import { setSubtreeVisibility } from "molstar/lib/mol-plugin/behavior/static/state";
import { MolScriptBuilder } from "molstar/lib/mol-script/language/builder";

const runtime = {
  createPluginUI,
  renderReact18,
  PluginUIContext,
  PluginContext,
  PluginConfig,
  PluginSpec,
  DefaultPluginUISpec,
  PluginCommands,
  StateSelection,
  StateTransform,
  StateBuilder,
  createStructureRepresentationParams,
  PluginStateObject,
  OverpaintStructureRepresentation3DFromBundle,
  QualityAssessment,
  MAQualityAssessment,
  Model,
  Structure,
  StructureElement,
  StructureProperties,
  StructureQuery,
  AtomicHierarchy,
  atoms,
  Color,
  ParamDefinition,
  round,
  clamp,
  SingleAsyncQueue,
  ScatterPlotSvg,
  ParameterControls,
  useBehavior,
  setSubtreeVisibility,
  MolScriptBuilder,
};

if (typeof globalThis !== "undefined") {
  (globalThis as typeof globalThis & { Molstar?: typeof runtime }).Molstar =
    runtime;
}

export type MolstarRuntime = typeof runtime;
export default runtime;
